import websitesService from "@/services/websites";
import serviceHandler from "@/helpers/handlers/service";

import moment from "moment";
import { isArray, mergeWith, omit } from "lodash";

export default {
  name: "AnalyticsData",
  props: {
    selectedItem: {
      type: Object,
      default: () => {}
    },
    paginationDate: {
      type: Object,
      default: () => {}
    }
  },
  data: () => ({
    audit: null,
    loaded: false,
    chartLoaded: false,
    websites: [],
    selectedWebsiteData: {},
    auditsHistory: {}
  }),

  watch: {
    selectedItem(newVal) {
      this.fetchWebsiteLastAuditData(newVal);
      if (Object.values(this.paginationDate).length > 0)
        this.fetchHistoricalAudits(this.paginationDate);
    },

    paginationDate(newVal) {
      this.fetchHistoricalAudits(newVal);
    }
  },

  computed: {
    formattedAuditsHistory() {
      if (this.auditsHistory.data && this.auditsHistory.labels) {
        return {
          data: omit(this.auditsHistory.data, "pwa"),
          labels: this.auditsHistory.labels
        };
      }
      return {
        labels: [],
        data: []
      };
    }
  },

  async created() {
    await this.fetchWebsites();
  },

  methods: {
    async fetchWebsites() {
      const data = await serviceHandler(websitesService.getWebsitesData());

      if (data.length > 0) {
        this.websites = data;
      }
      this.loaded = true;
    },

    async fetchWebsiteLastAuditData(value) {
      this.loaded = false;

      const data = await serviceHandler(
        websitesService.getLastQualityAudit(value.data.id)
      );

      this.audit = data && data.length > 0 ? data[0] : null;
      this.loaded = true;
    },

    async fetchHistoricalAudits(value) {
      this.chartLoaded = false;

      const data = await serviceHandler(
        websitesService.getHistoricalAudits(this.selectedItem.data.id, value)
      );

      let payload = {
        labels: [],
        data: []
      };

      if (data.length > 0) {
        if (data.length > 1) {
          data.reverse();

          const customizer = (objValue, srcValue) => {
            if (isArray(objValue)) {
              return objValue.concat(srcValue * 100);
            }
            return [objValue * 100, srcValue * 100];
          };

          payload = {
            labels: data.map(item =>
              moment(item.created_at).format("DD MMM YY")
            ),
            data: data.reduce((previousValue, currentValue) => {
              if (previousValue.scores && currentValue.scores) {
                return mergeWith(
                  previousValue.scores,
                  currentValue.scores,
                  customizer
                );
              }

              return mergeWith(previousValue, currentValue.scores, customizer);
            })
          };
        } else {
          payload = {
            labels: [moment(data[0].created_at).format("DD MMM YY")],
            data: Object.values(data[0].scores).map(item => [item * 100])
          };
        }
      }

      this.auditsHistory = payload;

      this.chartLoaded = true;
    }
  },

  render() {
    const slot = this.$scopedSlots.default({
      loading: !this.loaded,
      loadingChart: !this.chartLoaded,
      audit: this.audit,
      websites: this.websites,
      auditsHistory: this.formattedAuditsHistory
    });

    return Array.isArray(slot) ? slot[0] : slot;
  }
};
